import type { PageFragment } from "@/generated/client.generated";
import { HorizontalSpacer } from "../layout/horizontal-spacer";
import { VerticalContainer } from "../layout/vertical-container";
import RichTextJsonRenderer from "./rich-text-json-renderer";
import { Text } from "./text";

interface TextToRichTextProps {
  page: PageFragment;
}
// Skal kun brukes i migreringsfase mellom ren tekst i Strapi og RichText
export const HandleTextToRichText = ({ page }: TextToRichTextProps) => {
  return (
    <>
      {page.descriptionRichText ? (
        <VerticalContainer horizontalPlacement="left">
          <RichTextJsonRenderer
            alignTextHorizontally="left"
            textTheme="dark"
            content={JSON.parse(page.descriptionRichText)}
          />
          <HorizontalSpacer size="large" />
        </VerticalContainer>
      ) : (
        page.description &&
        page.description.trim() !== "" && (
          <>
            <Text value={page.description} />
            <HorizontalSpacer size="large" />
          </>
        )
      )}
    </>
  );
};
